import Tebex from '@tebexio/tebex.js'
import { appearance, isSmallScreen, lockScroll, tebexLocale } from './embed'

// the portal on its own, where customers log in with the email address of their checkout
const hostedPortalUrl = 'https://portal.tebex.io'

// same as for the checkout: tebex.js throws while its lightbox is still opening or open
let launching = false
// the portal is a global singleton as well, so only the listener of the latest launch may stay active
let unsubscribe = () => {}

export function useTebexPortal() {
  const config = useRuntimeConfig()
  const site = useSiteConfig()
  const { localeProperties } = useI18n()

  const launchPortal = async () => {
    if (launching || Tebex.portal.isOpen) {
      return
    }

    // small screens get the hosted portal in a new tab, as it needs nothing from our page and never returns to it
    if (isSmallScreen()) {
      window.open(hostedPortalUrl, '_blank', 'noopener')
      return
    }

    Tebex.portal.init({
      token: config.public.tebexWebstoreId,
      locale: tebexLocale(localeProperties.value.language),
      // the portal is served over https, so it only loads the logo over https (not from a local http dev server)
      logo: `${site.url}/images/logo.png`,
      ...appearance,
    })

    unsubscribe()
    unsubscribe = Tebex.portal.on('close', () => lockScroll(false))

    launching = true
    lockScroll(true)
    try {
      await Tebex.portal.launch()
    }
    catch (e) {
      console.warn('failed to launch tebex portal, falling back to hosted portal', e)
      lockScroll(false)
      // a new tab would be blocked after the failed launch, as it's no longer part of the click
      await navigateTo(hostedPortalUrl, { external: true })
    }
    finally {
      launching = false
    }
  }

  return { launchPortal }
}
